export interface BookEntry {
  title: string
  author: string
  date: string
  content?: React.ReactNode
  url?: string
}

export const readingJournalEntries: BookEntry[] = [
  {
    title: "Built to Last: Successful Habits of Visionary Companies",
    author: "Collins, Jim; Porras, Jerry I.",
    date: "9/21/2022",
    content: (
      <p>They sure reiterate their findings!—That’s a joke because it is very repetitive. The ideas are great, though. Preserve the core, stimulate progress; be a watch-maker, not a time-teller; create alignments and eliminate misalignments. Bam.</p>
    ),
  },
  {
    title: "Faith Without Certainty: Liberal Theology in the 21st Century",
    author: "Rasor, Paul",
    date: "5/10/2021",
    content: (
      <p>A quick brush of many different ideas. Does Rasor contribute anything original? Certainly, there is value in processed information: I couldn’t have learned as much if you’d given me all the original text referenced because of the approachability and time factors. I took a lot of notes to process during my next round of composition.</p>
    ),
  },
  {
    title: "Existential Psychotherapy",
    author: "Yalom, Irvin D., MD",
    date: "4/9/2021",
    content: (
      <p>Lacks the rigor in system I prefer, but I get the argument in appeal to the nature of topics and audience: conveying concepts like these along with values and attitudes is much faster if you use personality and art than formal language. The obvious takeaway is a revisit in adult life of “basic” ideas: death, freedom, responsibility, will, isolation, meaning(/lessness), existential anxiety.</p>
    ),
  },
  {
    title: "Gaslighting: Recognize Manipulative and Emotionally Abusive People—and Break Free",
    author: "Sarkis, Stephanie Moulton, PhD.",
    date: "4/2021",
    content: (
      <p>This book seems like it was cranked out pretty fast: there are a lot of typos and some repetition. The “resources” section is shallow. However, the author is clearly experienced and knowledgeable about this nontraditional topic and presents information in a way that will support and empower people dealing with gaslighting. Unfortunately, along with the thin “resources”, there is a suspicious lack of citations. The follow-up action steps are good.</p>
    ),
  },
  {
    title: "Love and Living",
    author: "Merton, Thomas; eds. Burton, Naomi; Hart, Patrick, Br.",
    date: "3/2021",
    content: (
      <p>A few enlightening insights, but not all very clear. The second half delved deeply into traversing Christian dogma rather than unbranded religious inspiration.</p>
    ),
  },
  {
    title: "The Consolation of Philosophy",
    author: "Boethius, Anicius Manlius Severinus; trans. Slavitt, David R.",
    date: "1/27/2021",
    content: (
      <p>Parallel to one of my book ideas in concept, though more focused and primary. That’s why I read it—inspiration/research for my own work, and to make sure what I have to say is original (yes). “Consolation” is one of the most beautiful, uplifting and valuably morally didactic books I have ever read (top 5). My outlook on life and my appreciation for God improved.</p>
    ),
  },
  {
    title: "Out of the Flames: The Remarkable Story of a Fearless Scholar, a Fatal Heresy, and One of the Rarest Books in the World",
    author: "Goldstone, Lawrence and Nancy",
    date: "1/24/2021",
    content: (
      <>
        <p>A fast-paced and systematically backstorying rendition of the important drama(s) of Michael Servetus’s life and of the “Christianismi Restitutio”. The authors use a nice balance of supported fact-finding with contemporary language register. I took several entries from the bibliography/further reading into my reading list.</p>
        <p>A keeper quote: “God himself is our spirit dwelling in us and this is the Holy Spirit within us. In this we testify that there is in our spirit a certain working latent energy, a certain heavenly sense, a latent divinity and it bloweth where it listeth and I hear its voice and I know not whence it comes nor whither it goes.” – Servetus (p. 301)</p>
      </>
    ),
  },
  {
    title: "How to Put More Time in Your Life",
    author: "Scott, Dru, PhD",
    date: "1/3/2021",
    content: (
      <p>Takeaways: how to be a little bit pushier about getting your needs met; suffering is overrated / don’t do stuff that doesn’t need to be done (→ this whole website and all its contents...lol <a href="https://www.youtube.com/watch?v=3Q9rewnLFYw" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">I can’t stop</a>).</p>
    ),
  },
  {
    title: "Difficult Personalities: A Practical Guide to Managing the Hurtful Behavior of Others (and Maybe Your Own)",
    author: "McGrath, Helen, PhD; Edwards, Hazel, MEd",
    date: "12/8/2020",
    content: (
      <>
        <p>The value of this book, for me, was in the highly technical and detailed descriptions it provides of personality characteristics and behaviors (a) identifying them, (b) naming them, and (c) explaining why it is toxic. The authors described proper responses to these, but for me awareness and articulate identification is half the solution. These traits <em>are</em> relatively elusive to identify and articulate, so the focused nail-down of these characterizations <em>is</em> a job.</p>
        <p>There was a not-just-noticeable but frownable amount of repetition. There must have been some reorganization possible to eliminate the redundancy. It seems like filler. That’s not a deal-breaker. I would consult this book again if dealing with a social problem.</p>
      </>
    ),
  },
  {
    title: "Warning Signs",
    author: "White, Stephen",
    date: "11/17/2020",
  },
  {
    title: "The King of Torts",
    author: "Grisham, John",
    date: "9/14/2020",
    content: (
      <p>Technically & practically instructive, this was the most memorable Grisham book I’ve read. I got my wish! (See entry for “The Summons”.)</p>
    ),
  },
  {
    title: "The Broker",
    author: "Grisham, John",
    date: "9/10/2020",
    content: (
      <p>An unnatural set of circumstances compared to “The King of Torts”. This spy stuff is not Grisham’s strong suit, but he acknolwedges that. A satisfying conclusion. Culturally instructive.</p>
    ),
  },
  {
    title: "The Summons",
    author: "Grisham, John",
    date: "9/4/2020",
    content: (
      <p>From this story we get Mr. Patton French, whose boat is named, and whose practice makes him, “The King of Torts”—a supporting character in this book who seems to’ve gotten his own book. I liked that character; I would (later did) read that book. This one came to a rapid conclusion. The ending is “morally instructive,” said a reviewer.</p>
    ),
  },
  {
    title: "War and Peace",
    author: "Tolstoy, Leo",
    date: "7/2/2020",
    url: "/publications/literary/reviews/wp.pdf",
  },
  {
    title: "The Genesis of Science: How the Christian Middle Ages Launched the Scientific Revolution",
    author: "Hannam, James",
    date: "6/15/2020",
    content: (
      <p>Sets a good example for: how to use narrative voice in non-fiction writing, how to be thorough, how to stick to your concept. Helped me to refine my concept for my book in philosophy of science + list of sources and ideas.</p>
    ),
  },
  {
    title: "“Darn It!” and “Screw It!” (2 titles)",
    author: "Williams, Sarah; Smith, Aubrey (respectively, not co-authors)",
    date: "5/17/2020",
  },
  {
    title: "Dangerous Mystic: Meister Eckhart’s Path to the God Within",
    author: "Harrington, Joel F.",
    date: "4/18/2020",
    content: (
      <>
        <p>I bought this book for help understanding my spiritual experience, and in fact much of this helpfully matched and named phenomena in my experience. Secondarily I much enjoyed reading the fascinating historical context about Paris and Germany.</p>
        <p>Eckhart’s theories of the divine spark and breaking through (pp. 232-3) recall the Taoist notion of sources of the dual phases existing in the hearts of their opposites. That that process can only occur upon the purification of the soul, and that all movement of a damaged or unclean heart (in metaphor) makes sense to one who has lived these ideas. The idea of valuing penance and holy works only for their purifying effects, not intrinsically, matches with the spiritual-scientific process Eckhart describes of finding one’s path to God experientially (pp. 92-3, 96) by trying options for their potentials. This sense of spiritual direction helped me to understand and recover from my own blindness and futile efforts. The negative theology (p. 165)—abandoning the notion of spiritual progress as willful (p. 105), letting God pull us in (p. 173), ... —works for me but I understand a phasic effort, taking turns with active and passive processes. Finally the notion also found in Buddhism of the suffering caused by attachment appears (pp. 97, 239) within Eckhart’s theory of spiritual progress and relapse, which very much coincides with the Christian theology later described succinctly by Weber.</p>
      </>
    ),
  },
  {
    title: "Essential Writings",
    author: "Emerson, Ralph Waldo",
    date: "4/5/2020",
    content: (
      <p>Mr. Emerson, there are many points in which I agree with you, such as in the take-what-you-need-and-leave-the-rest from Christianity. However, with respect, I found this unreadable. I suppose this writing is from a time when literacy rates were not as high and all books were valuable without much concern for quality? This is not a criticism of the inspiration or of the ideas themselves, but of the form of delivery. I am sure I would have liked to meet you, but I cannot read your writing.</p>
    ),
  },
  {
    title: "The Spaceship Next Door",
    author: "Doucette, Gene",
    date: "4/5/2020",
    content: (
      <p>I bought this book on a whim for a fun break from very heavy reading. Despite a decrease in mechanical correctness towards the end, I liked it. The prose and dialog were in-touch, plot original and didn’t cross the line to ridiculous, pacing energetic but sustainable, overall concept very intelligent. Two points of feedback would be: steer towards controlled and rationally developed endings instead of <i>deus ex machina</i>; and, the Cambridge-educated author is obviously highly literate but could’ve shared more culture, knowledge, or language art to edify besides entertain the reader. A-.</p>
    ),
  },
  {
    title: "Unjust: Social Justice and the Remaking of America",
    author: "Rothman, Noah",
    date: "3/31/2020",
    url: "/publications/literary/reviews/usjra.pdf",
  },
  {
    title: "Atonement",
    author: "McEwan, Ian",
    date: "3/29/2020",
    content: (
      <>
        <p>(This book was previously entered in this journal on 6/8/2018.) How like Hofstadter’s “Gödel, Escher, Bach: an Eternal Golden Braid” in its circuitousness, recursion, encapsulating itself and even Quine-like straw-man criticizing itself (the in-novel publisher’s feedback to Briony). The art is not in McEwan’s evocation of imagery: Briony’s editor cancels all criticism on those lines. The art is in the tension: the domestic inanities, the wildernesses of self-doubt, the war, the hospital, the flat—a challenge to read for the stretch of the reader’s disbelief in the likelihood of so much drama in one thread. But! I did find myself unwilling to focus on anything else until I was done with this book.</p>
        <p>I noticed the influence of Woolf before Briony’s editor mentioned it— McEwan uses the magnifying lens Woolf invented. It would’ve been interesting to also tell Lola’s side and, in my opinion, would’ve made for a truly monumental achievement. As it is, the book is “just” one great idea sprinted out, not the kind of planned, structured, rounded out and balanced novel with some depth and dimension that the great classics are so for being. That takes a different kind of inspiration: working and re-working. The great sprint is a different kind of achievement. Ultimately, Briony, Robbie and Cecilia were all on the same side; an interwoven narration of Lola’s and Paul’s side would have made for a balanced book. That would’ve meant less attention paid to Briony, and to the feelings, and more to the reader’s moral edification. It would’ve been a more psychological book.</p>
        <p>“Atonement” seems like McEwan was a passenger in his own creative process, done with an attitude of professionalism; but it is not an agentic, structured job—which does not detract from the quality, but does expose the flaw of one-sidedness not present when the artist/worker reaches the end of the process and returns to fully master the concept, principle, or subject, doing the work at least once again. </p>
      </>
    ),
  },
  {
    title: "Civil Disobedience",
    author: "Thoreau, Henry David",
    date: "3/25/2020",
    content: (
      <p>A favorite quote: “The mass of men serve the state...with their bodies...Others...serve the state with their heads...A very few...serve the state with their consciences also, and so necessarily resist it [the state] for the most part; and they are commonly treated as enemies by it.” Thoreau was an original thinker and a visionary. He might have been of Plato’s philosopher-king mold but for his physical constitution. The pure Idea Man only succeeds in a niche; what Thoreau gets right, and very right, in this essay are the principles, but he takes them too far until they are no longer pragmatic. William Rounseville Alger’s admonition of Thoreau’s naïvete and self-conceit are exquisitely precise; but Thoreau is not all bad. If only he could have subordinated his genius to a practical purpose other than admiring his ideas...but Alger even makes very close to that point, too. The takeaways for me are in Thoreau’s roasters (the edition I read included a lot of contemporary commentary, much negative): RLS also has some strong corrective insights, esp. re: the vice, not virtue, in avoiding society’s and life’s “rubs and trials” and pleasures and work.</p>
    ),
  },
  {
    title: "Acceptance: Loosing the Webs of Personal Insecurity",
    author: "Baker, Don",
    date: "2/28/2020",
    content: (
      <p>At first a helpful concept but it dove too deeply into Christian dogma for me. I can ride the ride if the author stays on topic (acceptance and emo. security), but this was a conversion text in sheep’s clothing.</p>
    ),
  },
  {
    title: "Welcome: A Unitarian Universalist Primer",
    author: "Frevert, Patricia (ed.)",
    date: "2/27/2020",
    content: (
      <p>It took me more than a year to process this—to close the spiritual distance between these ideas and me. Lots of the Worship Readings and Quotable Quotes had ideas that struck harmonious chords with my thinking.</p>
    ),
  },
  {
    title: "The Prince",
    author: "Machiavelli, Niccoló",
    date: "2/11/2020",
    content: (
      <p>These are ways of thinking suited to a society or world without stable power structures. I live in a world with a stable social and political order. Globalism, the epoch of global resource security, ended the squabbles over unsecured power/resources, which are in many ways two sides of the same coin. I learned some about political stratification and liberty, subtle insights, but ultimately rejected these ideas as being too primitive—in some sense, I already knew this stuff. The practical lessons Machiavelli means to convey will either be obvious to anyone capable of leadership, or in his/her blind spot regardless of the pedantry. From the get-go we see an attempt to be systematic, but the system is not complete or balanced or really realistic—at least in a world with some justice, where that justice flows. </p>
    ),
  },
  {
    title: "It",
    author: "King, Stephen",
    date: "2/8/2020",
    url: "https://docs.google.com/document/d/1sSUwJEWY2lgs8SwODZD2SNTJZ6ijGhimQp5-06xAyQs",
    content: (
      <p>I wrote enough about this to link to it separately, but not enough to list it on my publications page.</p>
    ),
  },
  {
    title: "The Lincoln Lawyer",
    author: "Connelly, Michael",
    date: "12/18/2019",
    content: (
      <p>When I read fiction, I look for either edification or entertainment. TLL was great entertainment. A great concept—lots of intrigue so that I couldn’t predict the end. I enjoyed reading about Connelly’s resourceful and professionally executed research activities in his note at the end.</p>
    ),
  },
  {
    title: "Mrs. Dalloway",
    author: "Woolf, Virginia",
    date: "12/3/2019",
    content: (
      <p>The reason I read “Mrs. Dalloway” is, an ancient (2011) repeated insistence from my then-girlfriend which lately I was unable to psychologically sidestep. At first I found the titular character to be a disempowered, self-absorbed neurotic. Then I understood that she chose to use her powers for a social purpose, and that the anchorlessness and the “standing drenched in fire” is the gift she gave those around her—she’s an oracle and a conduit. There’s a lot to say about this book, but I won’t do a full analysis because I didn’t like it. There was one takeaway gold nugget: “hatred is for ideas, not people.”</p>
    ),
  },
  {
    title: "The Road",
    author: "McCarthy, Cormac",
    date: "10/31/2019",
    content: (
      <p>Writing a story about postapocalyptic bleakness presents the challenge of actively balancing the suffering and drama inherent in such a story with the reader’s needs for both a light at the end of the tunnel and adequate detail and realism to maintain interest. McCarthy rises to the challenge. Nowhere, here not an exception, do I like sentence fragments, despite recognizing the artistic value, but for McCarthy it wasn’t a dealbreaker. Much thanks for a happy ending. I wept.</p>
    ),
  },
  {
    title: "The Laws of Medicine",
    author: "Mukherjee, Siddartha",
    date: "10/27/2019",
    content: (
      <p>If Mukherjee were here I would say, I can appreciate the obvious depth and dimension of your perspective. This is true wisdom. But, playfully, as far as the book, bro, talk about mailing it in. What a cash-in. Oh, well, I ain’t mad at ya. Separately, I’m not sure I learned anything from this one.</p>
    ),
  },
  {
    title: "Your God is Too Small",
    author: "Phillips, J. B.",
    date: "10/18/2019",
    content: (
      <p>The titular concept says most of it, but not until the last dozen pages did my spiritual status accept the change that the title suggests. Phillips suggests that the “system” of the world is a closed system and, though large, nonetheless limits experience. (So do some of the religious concepts Phillips ID’s at the beginning of the book, but the later statement connected with me better.) The idea of a system which is religious, but also insistently open to accepting God’s gifts however he may choose to give them, is the contribution of this book and, for me, I’m grateful. This book challenged me.</p>
    ),
  },
  {
    title: "The Bone Labyrinth",
    author: "Rollins, James",
    date: "10/7/2019",
    content: (
      <p>Wow, what a trip. I can’t say I didn’t enjoy it. Monster genetically engineered gorillas; rediscovery and exploration of Atlantis; international kidnapping... there is so much here, Rollins must be a creative genius to weave this all together so well. Yeaahhhhhhhhh! Lauded by both Lee Child and Brad Thor. I think Thor’s comment was, in effect, this book will remind you why you fell in love with reading. Yeah!</p>
    ),
  },
  {
    title: "Bad Luck and Trouble",
    author: "Child, Lee",
    date: "6/30/2019",
    content: (
      <p>Oh yeah, Jack Reacher. Can’t get enough. More of the same—good old fashioned book stories. Gotta love it. “The Killing Floor” was my favorite, but they’re all good. This one was good, too.</p>
    ),
  },
  {
    title: "Night",
    author: "Wiesel, Elie",
    date: "5/2/2019",
    content: (
      <p>I’ve read “Man’s Search for Meaning” by Frankl; this book added to the documentation, and showed other scenes. In some ways more revealing than Frankl.</p>
    ),
  },
  {
    title: "Invisible Man",
    author: "Ellison, Ralph",
    date: "4/26/2019",
    content: (
      <p>Ellison had a gift for giving the reader an appropriate sense of things. The question is, was he aware of the author’s gift, and was he conscious of his responsibility to use that gift with definite purpose? Separately, let me be “on the yam level” all my life!</p>
    ),
  },
  {
    title: "The Social Construction of Reality",
    author: "Berger, Peter L.; Luckmann, Thomas",
    date: "4/1/2019",
    content: (
      <p>World-changing. I would love to discuss this book.</p>
    ),
  },
  {
    title: "The Prophet",
    author: "Gibran, Kahlil",
    date: "3/1/2019",
    content: (
      <p>There were a lot of profound ideas in “The Prophet”. There were maybe a couple or few powerful insights. However, a lot of this lost me. The pornography was cool. The last image, of the cyclops hand in a cloud of wings, I liked.</p>
    ),
  },
  {
    title: "The Little Prince",
    author: "de Saint-Exupéry, Antoine",
    date: "2/1/2019",
    url: "/publications/literary/reviews/tlp.pdf",
  },
  {
    title: "Leviathan",
    author: "Hobbes, Thomas",
    date: "1/19/2019",
    content: (
      <p>Book one seemed to be Hobbes “thinking out loud,” to warm up, with, to me, the only notable idea that language forms the structure of abstract thought. Book two is the heart where we find a full foundation for the idea of the social contract, starting with anarchic or ungoverned people described as in a war of every person against every person. Hobbes continues to provide the entire thought-content equivalent of Rousseau’s Social Contract book (a hundred years earlier) and continues on to describe law and government. Most of the particulars reference the English system, though Hobbes means to be culture-independent by basing his theory of power structures on universal moral law, God’s law. Hobbes does a very good job of describing moral science as the method by which reason informs us of universal (or natural, or God’s) law, and of explaining that law, what there is to say, its origin and how to reason within its framework, etc. Takeaways: some particularly high-level insights into the nature of God’s law, order and disorder.</p>
    ),
  },
  {
    title: "On the Social Contract",
    author: "Rousseau, Jean-Jacques",
    date: "12/28/2018",
    content: (
      <p>Goes very far into the evolution of the structure of the Roman government as an exploration of concepts. That part isn’t very enlightening for the reader. The main ideas of the book are that: right of rule by force can’t create a stable social order; right of rule by claim (of God’s favor) is flawed; power dynamics sort out stably under a system of social contract. Social contract means that everyone gives up his right to self-govern, and gives that right to everyone else. Under that system, the people’s collective will (the sovereign) finds voice and force through representation of its own choosing. According to Rousseau, the right to govern can only be granted by those who are governed. Besides these important concepts, I also appreciated Rousseau’s opinions (some hilariously and self-consciously mad, some astoundingly insightful) about religion/spirituality, as-such and <i>w.r.t.</i> the state. Interestingly, Rousseau provides a one-page chapter describing the mental transformation that takes place when an individual undergoes the social process inducting him/her from the Hobbesian “state of nature” into a well-established social order (à la Weber, esp. as described in my paper). Thanks to Michael for gifting me this book.</p>
    ),
  },
  {
    title: "Anti-Cancer: A New Way of Life",
    author: "Servan-Schreiber, David, MD, PhD",
    date: "11/26/2018",
    content: (
      <p>I couldn’t read the entire book due to unresolved trauma, but: refer back when planning a diet/lifestyle, for at-a-glance tables of unhealthy vs unhealthy foods/etc. I internalized a lot of these practices, and have lost weight and feel better as a result.</p>
    ),
  },
  {
    title: "The Gene",
    author: "Mukherjee, Siddartha",
    date: "9/6/2018",
    content: (
      <p>Somewhat repetitious towards the end. I learned about Linus Pauling’s 1951 paper, understanding which will be a good goal. I also got caught up on recombinant methods, and a reminder of the concepts and terms a college prof. taught me: various gene-seq methods, DNA concepts, .... Together this and “Emperor” filled in gaps in my understanding which would have been helpful at work in this field in 2011-12.</p>
    ),
  },
  {
    title: "The Emperor of all Maladies",
    author: "Mukherjee, Siddartha",
    date: "8/18/2018",
    content: (
      <p>A fast-paced, dramatic history told with emotional investment and authority. I learned about cell-signaling pathways and other cell mechanics affected in cancer. The concepts of “rational drug design” / “molecular epidemiology/medicines” based in a “mechanistic understanding of cancer” I understood intuitively and was thinking about before reading, but needed to learn the names for.</p>
    ),
  },
  {
    title: "The Essential Jung",
    author: "Jung, Carl; ed. Storry, Anthony",
    date: "8/14/2018",
    content: (
      <p>A compilation of excerpts emblematic of Jung’s thinking, piecewise by topic. Relevant and helpful but respectfully unobtrusive comments by Storr, interspersed throughout, provide perspective and orientation to 400 pages of highlights of Jung’s work. I found a lot of helpful and supportive observations about the nature of the mind, recovery from trauma, and personality development in here. I sought more by Jung after reading “Modern Man in Search of a Soul”. I wanted to learn about synchronicity and to find out whether any of Jung’s concepts were relevant to my own philosophical ideas—turns out, no, but archetypes and “anima/animus” were important to understand...they show up occasionally [I mean elsewhere than this book]. And it was good to have investigated the lead.</p>
    ),
  },
  {
    title: "Letters to a Young Poet",
    author: "Rilke, Rainer Maria",
    date: "8/10/2018",
    content: (
      <p>So many truths. I especially liked the ideas: solitude as a process that transforms and builds character; love should not be enmeshment of two underripe individuals, but a constant conversation between two independent ones. Wait for that love. Thanks to L.S. for prescribing this book for me.</p>
    ),
  },
  {
    title: "Faust",
    author: "Goethe, Johann Wolfgang von",
    date: "7/13/2018",
    content: (
      <p>I was not incredibly impressed with the book. He wrote it over the course of something like 60 years, and I guess it is that he only used the very best inspiration available to him to write it, and that’s why it’s a masterpiece, because it is imbued with certain properties ... but, when 98% was a poem, and then like 2-3 pages towards the end were in prose, that was weird... and as far as plotting... maybe it’s that treating of “Deals with the Devil” is a rare responsibility, and Goethe discharged it very well? I don’t know. Takeaways: it changed me, conditioned me, focused me towards the ends of literature as an enterprise. It purified my psyche, healing some of the corruption. That’s all very subconscious, but I was aware of it happening. I pay attention to what’s going on in my life while I read a book—like synchronicity.</p>
    ),
  },
  {
    title: "Modern Man in Search of a Soul",
    author: "Jung, Carl",
    date: "7/9/2018",
    content: (
      <p>Notes, separately. This book helped me to heal. Lots to say.</p>
    ),
  },
  {
    title: "Pilgrim’s Progress",
    author: "Bunyan, John",
    date: "6/23/2018",
    content: (
      <p>Wow, so amazing, original and skilled. I would love to discuss this book with another pilgrim. I have my notes ready. Update 11/28: I finished Part II. The reason I had only read Part I before was, I got the gist and I figured the 2nd half would be more of the same. It was. But I still enjoyed it.</p>
    ),
  },
  {
    title: "Teilhard de Chardin: A New Synthesis of Evolution",
    author: "Kopp, Joseph V.",
    date: "6/20/2018",
    content: (
      <p>Didn’t like it. Very problematic, in terms of science. De Chardin’s idea of a harmonious society is great, but his ideas about evolution are not correct.</p>
    ),
  },
  {
    title: "Who Moved My Cheese?",
    author: "Johnson, Spencer, MD",
    date: "6/10/2018",
    content: (
      <p>Change, what it means, how it affects us psychologically, what to do about it, why moving with it matters, why resisting it is unhealthy. Got it. Thanks.</p>
    ),
  },
  {
    title: "Atonement",
    author: "McEwan, Ian",
    date: "6/8/2018",
    content: (
      <p>I read 1/3 of this book before rejecting it. Talk about stagnation! My cuticles were more interesting than this book: I often found myself staring at them without noticing I’d put the book down. Reading this book was like atonement for a sin I hadn’t committed. An apt title (in an ironic sense) for a punishing book. No, thank you!</p>
    ),
  },
  {
    title: "Candide",
    author: "Voltaire",
    date: "6/3/2018",
    content: (
      <p>I read 1/3 of this book twice in my past, giving up both times. This time it was a quick read, maybe 2 hours total. Clearly a combination of social commentary and self-expressive existential rant. I didn’t dislike it, but I guess I wasn’t really enthused. Maybe it would’ve been more entertaining when written, when social commentary was a bolder thing to do. Takeaways: I don’t even know if it was from this book, but while I was reading this book I saw somewhere the French idiom “passion for dirt,” which I stuck in a file somewhere to use in literature of my own. Other takeaway: executive plotting style. Voltaire moves swiftly. It’s not something to use everywhere, but sometimes when you’re stuck, you just gotta get bolder, care less about clean breaks and clean lines and go for the <i>deus ex machina</i>. That’s a valuable lesson.</p>
    ),
  },
  {
    title: "Doctor Zhivago",
    author: "Pasternak, Boris",
    date: "4/1/2018",
    url: "/publications/literary/reviews/dr-z.pdf",
  },
  {
    title: "Atlas Shrugged",
    author: "Rand, Ayn",
    date: "4/1/2018",
    content: (
      <p>I read 90% of this book in 2012, actually only skipping 75% of Galt’s speech. In 2014 I was walking the side of the highway in Montana when a stranger stopped his truck 100ft ahead of me, got out walking around the front of the truck to open the passenger door, and walked around again and got in (I didn’t see him, meaning), so I had to make a decision within about 10-15s whether I would get in or not. Based on the following: that this was Montana; that the vehicle was a nice-looking duty pickup truck; that the license plate said [something in reference, unmistakably, to an Ayn Rand novel, but for privacy I will omit to cite]  I reasoned that the driver was an Ayn Rand fan, and therefore safe. My friends tell me this is sound logic. And the topic of Atlas Shrugged did come up: “Yes,” I said, I read it, and he asked: “but did you read all of Galt’s speech?” and “No,” I had to honestly say. So I obviously had to go back and read the rest of the speech. This time around I just read the 60pp that I had skipped before. Takeaways: an improved sense of im/morality, integrity, and the difference between money and value, and .</p>
    ),
  },
  {
    title: "Walden",
    author: "Thoreau, Henry David",
    date: "3/27/2018",
    url: "/publications/literary/reviews/walden.pdf",
  },
  {
    title: "Pride and Prejudice",
    author: "Austen, Jane",
    date: "3/24/2018",
    url: "/publications/literary/reviews/pride-prej.pdf",
  },
  {
    title: "The History Book",
    author: "DK (publisher)",
    date: "3/16/2018",
    content: (
      <p>Matte pages and a more common font would have improved readability (vs. glossy and a show font). The book comprised a series of articles each 1-4pp about individual events and their consequences, rather than a contiguous narrative or a division by historical periods. History from 200,000 years ago (the epoch of modern humans) up to present (published 2016 and running impressively current) was covered with exponential frequency in the articles. The style left plenty of room for the reader to draw connections and think critically about history to form his own understanding. History has never been my strong suit, so this book offered approachability. Takeaways: a fuller understanding of the role of the Catholic Church in Europe up through the Enlightenment. Some understanding of the forces of politics: the drives to power, and subsequently to democracy in the evolution of a people. (Even if sociocultural evolution theories have largely been rejected, um, they kind of seem to have some validity....) More exposure to the causes and effects of rapid political changes of the 20th century.</p>
    ),
  },
  {
    title: "Siddartha",
    author: "Hesse, Herman",
    date: "3/5/2018",
    content: (
      <p>Profound and spiritually insightful. This book challenged me, forced me to expand my thinking, and changed me. Reading this book brought me to a new level of understanding. Several of the passages caused me to re-awaken. The contrast of the falling leaf and the fixed course is good food for thought. The rebirth of Siddartha in the chapter “Awakening” (“I have, for the sake of a meaning I had anticipated before I read ... called the visible world a deception. ... No, this is over....”) was very meaningful for me.</p>
    ),
  },
  {
    title: "Healing the Shame That Binds You",
    author: "Bradshaw, John",
    date: "2/20/2018",
    content: (
      <p>Contains a lot of important ideas. Helped me to understand unhealthy psychological conditioning I suffered from unbeknownst, and to heal therefrom. This is one of those ones, like “Emotional Intelligence” and “Good to Great”, to keep in mind for real life.</p>
    ),
  },
  {
    title: "The Great Ideas in Philosophy (DVD) (2nd ed.)",
    author: "Robinson, Daniel; The Great Courses",
    date: "1/5/2018",
    content: (
      <p>Over the course of about 4-5 months I watched about 58/60 lectures, 30 min’s each, and took notes. Professor R. has a great subtle sense of humor, and is very effective at conveying the relative importance of ideas and getting his point(s) across. High quality, without a doubt. I would want Prof. R. as a friend. This was very fun, besides hugely edifying and many of these ideas are practical. This was definitely a worthwhile improvement opportunity.</p>
    ),
  },
  {
    title: "Moby Dick",
    author: "Melville, Herman",
    date: "12/28/2017",
    url: "/publications/literary/essays/und-md.pdf",
    content: (
      <p>Takeaways: understanding of what it means to do intellectual work comprehensively. Melville must have kept a catalog of every thought he had about anything to do with sailing, whaling, whales, etc. and made sure all of that was in his manuscript. This book gave me some perspective on how to manage intellectual projects of vast scope.</p>
    ),
  },
  {
    title: "Essays of E. B. White",
    author: "White, E. B.",
    date: "11/24/2017",
    url: "/publications/literary/reviews/eb-white.pdf",
  },
  {
    title: "Great Expectations",
    author: "Dickens, Charles",
    date: "11/19/2017",
    url: "/publications/literary/reviews/great-exp.pdf",
  },
  {
    title: "Emotional Intelligence",
    author: "Goleman, Daniel",
    date: "11/11/2017",
    content: (
      <p>This book truly was the cure, for me, of impulse dyscontrol where mere discipline and therapy were ineffective. This book did it by explaining it to me in real terms instead of the hyper-simplified clinical version. Takeaways: concepts: emotional entrainment, mirroring, engaging in empathy while setting aside the specific issues, and many more, plus a huge amount of notes that I will return to later in life.</p>
    ),
  },
  {
    title: "Unbroken: A World War II Story of Survival, Resilience, and Redemption",
    author: "Hillenbrand, Laura",
    date: "11/5/2017",
    url: "/publications/literary/reviews/unbroken.pdf",
  },
  {
    title: "Further Out Than You Thought",
    author: "Carter, Michaela",
    date: "11/1/2017",
    content: (
      <p>Two twenty-somethings and one thirty-something are lost souls trapped in self-abusive patterns. They use drugs; they deny their futures; they engage in risky behaviors. The ending is satisfying because one of them breaks the cycle, though only because pregnancy forces her to do so. This book forced me to face shameful aspects of my own past, my own ignorance, my own irresponsible choices. My internalized parent’s alarm bell rang so many times that I got hypertension. Reading this book felt like what I imagine parenting to be like: flinching, wincing at poor choices and feeling pride in wise ones.</p>
    ),
  },
  {
    title: "Jane Eyre",
    author: "Brontë, Charlotte",
    date: "10/22/2017",
    url: "/publications/literary/reviews/jane-eyre.pdf",
    content: (
      <p>Classic. Because it’s so popular, it’s a good subject for conversation with others.</p>
    ),
  },
  {
    title: "Political Philosophy: A Very Short Introduction",
    author: "Miller, David",
    date: "10/6/2017",
    content: (
      <p>These VSI books have an enjoyable tone. This one was more of a brush than the other VSI books I’ve read - especially on the topics of (social) justice and feminism there were just some (top germaneness) remarks that did not satisfy my intellectual curiosity in these areas.</p>
    ),
  },
  {
    title: "Metaphysics: A Very Short Introduction",
    author: "Mumford, Stephen",
    date: "9/22/2017",
    content: (
      <p>A more informal (colloquial rather than academic) tone than other Very Short Introduction (VSI) books. A good introduction to the basic concepts. Takeaways: a few pages of notes.</p>
    ),
  },
  {
    title: "Good to Great: Why Some Companies Make the Leap...And Others Don’t",
    author: "Collins, Jim",
    date: "8/28/2017",
    content: (
      <p>Extremely intelligent, insightful, and inspiring research. Equally as instructive as the takeaways are the research methodology and clear-headed, inquisitive ethic. I internalized many of the key distillate ideas and still use them as situations calling for them arise.</p>
    ),
  },
  {
    title: "Home Run: Learn God’s Game Plan for Life and Leadership",
    author: "Myers, Kevin; Maxwell, John C.",
    date: "8/22/2017",
    content: (
      <p>A very normative perspective on self-esteem, connection with God, relationships with others, and repairing all of these. Takeaways: it is never too late to turn your life around; Some other concepts that have helped to shape my thinking about the ideal life, and how to heal relationships: connect with God and learn to depend on divine will; tame your ego; be secure in what you are doing; Romans 12:2: “Do not conform to the pattern of this world, but be transformed by the renewing of your mind. [...]”; the closer we get to God, the closer we get to each other.</p>
    ),
  },
  {
    title: "The Protestant Ethic and the Spirit of Capitalism",
    author: "Weber, Max",
    date: "8/16/2017",
    url: "https://docs.google.com/document/d/1iCqpmOO_uLknKsW8IoI5e_tBPjYEW-r6RuX7ViAGzXk",
    content: (
      <p>Offers bleeding-edge insights into the relationship between religion, spirituality, human psychology, and mental health.</p>
    ),
  },
  {
    title: "The Awakening",
    author: "Chopin, Kate",
    date: "8/5/2017",
    url: "/publications/literary/reviews/awk.pdf",
    content: (
      <p>The Awakening offers a Pandora’s Box of emotional intelligence.</p>
    ),
  },
  {
    title: "The Crystal Shard",
    author: "Salvatore, R.A.",
    date: "7/24/2017",
    content: (
      <p>The book that introduced one of the adventure/fantasy/D&D genre’s most famous characters, Drizzt Do’Urden, is full of empty pleasure. The story is magnificent; the characters are totally unafraid of death. Good use of dramatic tension. Takeaways: exposure to the genre I’m writing in.</p>
    ),
  },
  {
    title: "Postmodernism: A Very Short Introduction",
    author: "Butler, Christopher",
    date: "7/17/2017",
    content: (
      <p>I was pleasantly surprised that Butler so candidly called out postmodernists as typically unconstructive, uncooperative naysayers. As a movement postmodernism arose and developed, turned out not to be assimilable into mainstream thought, and disappeared. Did some legitimate work arise from the movement? Yes. Takeaways: an idea like “postmodernist creations are the products of a meaningless process of production that delivers no truth value” is so powerful, and showed me new possibilities of how to treat of ideas and arguments. This book was a tremendous learning experience with connections to topics that have been really weighing on my mind lately. It was meant to be.</p>
    ),
  },
  {
    title: "Mama Makes Up Her Mind",
    author: "White, Bailey",
    date: "6/29/2017",
    content: (
      <p>Mrs. White delivers mostly innocent anecdotes while slipping in a thin slice of the truth. I laughed a couple of times.</p>
    ),
  },
  {
    title: "The Inferno",
    author: "Alighieri, Dante; trans. Ciardi, John",
    date: "6/25/2017",
    content: (
      <p>A great text that shed important light, for me, on matters of morality I needed to know more about. Reading “The Inferno” was like having a half-dozen counseling sessions—incredibly beneficial—the fear of Hell has successfully been instilled in me. This book challenged me and affected me in positive ways.</p>
    ),
  },
  {
    title: "A Chosen Faith",
    author: "Buehrens, John A. and Church, Forrest",
    date: "6/23/2017",
    content: (
      <p>I took a lot of time to digest “A Chosen Faith” (ACF). I may revisit ACF once I have joined an actual Unitarian Universalist church. ACF got me thinking about spiritual metaphysics: Unitarian Universalism (UU) gets rid of original sin. That allows me to take responsibility for the sins that I commit, and to be responsible for the sins that I commit. Knowing that I am not intrinsically fatally flawed as a person actually gives me the self-esteem to try harder to be a better person. I wish to discuss this new idea (& others of liberal religion) with others so that I can understand them better. Liberal religious concepts are new to me because I was brought up in a Catholic home and went to Catholic schools, so I wish for guidance in thinking through these ideas. Takeaways: spiritual growth; freedom from unhealthy, binding beliefs; further reading: “The Humanist Manifesto”</p>
    ),
  },
  {
    title: "Foreign Influence",
    author: "Thor, Brad",
    date: "6/22/2017",
    content: (
      <p>Whereas “The Lions of Lucerne” was strictly business, “Foreign Influence” has some jokes for a mature audience. They were well-appreciated. This was a very fast, forgettable read, but nonetheless certainly enjoyable. I discovered I enjoy the covert-ops thriller genre whereas much of my reading (most) is purpose-driven. I guess I’ll look for more of these.</p>
    ),
  },
  {
    title: "Bowdrie",
    author: "L’Amour, Louis",
    date: "6/15/2017",
    content: (
      <p>Bowdrie is a Texas Ranger in the Wild West, a punchy, fast-drawin’, observant, judicious detective, an effective lawman and a bit of a ladies’ man, really. He has a sense of humor. What an entertaining book—simple stories that are pleasurable to read. Takeaways: vocabulary: leonine, puncher, rankle, and others. Storytelling tempo and character dynamics.</p>
    ),
  },
  {
    title: "Wish You Well",
    author: "Baldacci, David",
    date: "6/10/2017",
    content: (
      <p>Touching and well-rounded, full of the stuff life is made of. Enough honest sentiment and realistic, relatable conflict, plus morality and justice, to appeal to a wide audience. This book helped me.</p>
    ),
  },
  {
    title: "The Glass Bead Game",
    author: "Hesse, Herman",
    date: "5/30/2017",
    content: (
      <p>The concepts explored are very cerebral and nosebleed-level in complexity. Themes are discipline, hierarchy, utility, purpose, and the divide between academia and the “real world.” The book is a fictional biography, written as though by serious editors chronicling the life, achievements, personality and individuality of an administrator in a cloistered intellectual community who ultimately sets himself free by achieving total mastery of the institution and walking away. In my writing around this time, I noticed myself using the flourishes and vocabulary of the register Hesse employs in this novel. This book definitely sharpened me. Most of the time when I read books, I am working on bettering myself. This book was that too, but was pure (and purifying) entertainment. The characters are giant people. The spiritual and personal journeys told in these stories bore some similarity with my own experiences and shed light on some of the spiritual questions that I have struggled with. One of the most poignant books I’ve ever read, but has many other qualities.</p>
    ),
  },
  {
    title: "Rainbow Six",
    author: "Clancy, Tom",
    date: "5/9/2017",
    content: (
      <p>A thrilling piece of entertainment. I’m glad I read this book. It was a world-class way to unwind. Takeaways: insight into world politics and a reminder about how to be down-to-earth.</p>
    ),
  },
  {
    title: "Disease and History",
    author: "Cartwright, Dr. Frederick F.",
    date: "4/13/2017",
    content: (
      <p>Very dry. I missed the thesis, if there was one (I mean, I think there isn’t one). The book was a tour of chapters in history where disease affected the course of world events, or had large-scale impact. This was not an exhaustive survey, though, and didn’t seem like it was meant to be. It was just a handful of examples explored. Interesting stuff, but an odd book. Takeaways: further reading for my research pile.</p>
    ),
  },
  {
    title: "Don Quixote of La Mancha",
    author: "Cervantes Saavedra, Miguel de; trans. Starkie, Walter",
    date: "4/10/2017",
    content: (
      <p>Part 1 was better than Part 2. The joke in the first part was Quixote’s “astonishing” and ultimately harmless madness; in the second, the humor came from absurdity. Some of the scenes were funny enough I laughed out loud. Published in 1605/1615; I didn’t realize this kind of unleashed humor was around then. Indescribably entertaining and hilarious. I believe the correct pronunciation of “quixotic” is kee-HOH-tic after Quixote.</p>
    ),
  },
  {
    title: "A Man in Full",
    author: "Wolfe, Tom",
    date: "3/10/2017",
    content: (
      <p>A new adventure for me, with elements of style and character that I had not encountered in my reading yet. Charlie Croker seems unbelievably grand. Martha Croker is a very human character. A tremendous plot. When I finished and closed the book, I felt my operating voltage drop by about a third. Takeaways: inspiration in the way of artistic license to “paint” a story with priority regard for the artistic process and the reader’s experience rather than the rules of grammar and language mechanics.</p>
    ),
  },
  {
    title: "The Great Gatsby",
    author: "Fitzgerald, F. Scott",
    date: "2/27/2017",
    content: (
      <p>Of course I’ve read Gatsby before, but there was a passage I wanted to revisit: “... a certain physical decency established itself. Gatsby got himself into a shadow....” This is a profoundly spiritually insightful passage, and in my opinion is too much revelation for high school students. Fitzgerald has claimed that decency requires the physical arrangement of moral agents, with respect to light and shadow, to reflect the moral truth of the encounter. That is a lot to chew on for high-school students, most of whom will pass it by altogether, I guess. I am glad to have finally processed this gem.</p>
    ),
  },
  {
    title: "America’s Wars and Military Excursions",
    author: "Hoyt, Edwin P.",
    date: "2/24/2017",
    content: (
      <p>Very dry; told from outside the academic tradition (although published by McGraw Hill). Somewhat rogue in candor, yet not as revealing as “Understanding Power” by Chomsky. Hoyt was news editor for the U.S. Office of War Information, and a member of their psychological warfare team in India, Burma and China; newspaper reporter, editor, writer, and producer-director-writer for CBS TV news. This book tells raw stories in smart and highly informed language but still informal conversational tone. There are political incorrectnesses and heavy-handed judgments, insensitive jokes, and overall the tone is one of military intelligence but there’s also self-directed cynicism. This book is a brave project built on a lot of research by an independent commentator with a unique and valuable perspective. Takeaways: maturation of my overall attitude through exposure to cold, hard grown-up worldly knowledge.</p>
    ),
  },
  {
    title: "An Empire of Wealth",
    author: "Gordon, John Steele",
    date: "2/23/2017",
    content: (
      <p>The nation’s entire history is narrated in terms of the economy. A treasure chest of American economic history told with tolerable pace and thankfully with personality; written with great prose, research and structure; only criticism: a mote pedantic. Takeaways: increased familiarity with sky-high abstract Wall Street financial concepts; some additional topics for my research list (UN, IMF, etc.)</p>
    ),
  },
  {
    title: "Liberty’s Blueprint",
    author: "Meyerson, Michael I.",
    date: "2/21/2017",
    content: (
      <p>Extremely true to its purpose; squeaky clean prose; logical, straightforward, tough; brilliant and pure; pointed. An excellent product. Takeaways: orientation to and first steps along the lines of political thought of the founding fathers; a few additional titles for my reading list.</p>
    ),
  },
  {
    title: "Finding Your Religion",
    author: "McLennan, Scotty, Rev.",
    date: "2/15/2017",
    content: (
      <p>Stories of individuals’ spiritual journeys. Ultimately, sort of a (God, please don’t smite me for saying “final” and “enlightenment”) final struggle through the last of ignorance into enlightenment. There’s a concept of each spiritual tradition being one established path up a mountain, the peak of which is spiritual truth, and you can only be on one path at once, and you should be on an established path rather than wayward. There is a stage theory of spiritual development. Of course spirituality is not divisible into 5 discrete stages, but the characterizations are good food for thought. These have given me insight into reading others’ maturity not just in spirituality.</p>
    ),
  },
  {
    title: "The Everything Budgeting Book",
    author: "Stouffer, Tere",
    date: "12/10/2016",
    content: (
      <p>Takeaways: the skill of writing and continually re-assessing financial goals, financial assets, budgets, and household ledgers. The use of self-made worksheets for these purposes. I got the gist of a basic method for personal finance management from this book, and have moved forward from there.</p>
    ),
  },
  {
    title: "The Lathe Book: A Complete Guide to the Machine and its Accessories",
    author: "Conover, Ernie",
    date: "12/10/2016",
    content: (
      <p>Same as for “The Table Saw Book”, research for a career. The book is by a woodworker, and describes lathes for working wood products by hand; however, much of the terminology will carry to machine shop lathes.</p>
    ),
  },
  {
    title: "The Table Saw Book",
    author: "Mehler, Kelly",
    date: "12/10/2016",
    content: (
      <p>I was researching for a career option as a CNC machinist.</p>
    ),
  },
  {
    title: "Mad In America: Bad Science, Bad Medicine, and the Enduring Mistreatment of the Mentally Ill",
    author: "Whitaker, Robert",
    date: "11/29/2016",
    content: (
      <p>I need to follow-up and re-read this book.</p>
    ),
  },
  {
    title: "Addiction and Responsibility: An Inquiry into the Addictive Mind",
    author: "Seeburger, Francis F.",
    date: "11/25/2016",
    content: (
      <p>Sort of profound. There was a lot of discussion backing that addiction isn’t quite a disease, even though it has been called one. It is a pathological habit of mind. That’s not really a disease in the classical sense. (Update 2021: “Pleasure Unwoven” changed my mind the other way.) Insight: if a saint lives to serve God, a retail clerk on the job serves a customer, an addict lives to serve his addiction, a non-productive abstract entity. That’s kind of the thesis of the book. This concept translates to insanity as well, I think. You would have to press me to articulate how, but, it is a useful concept, I think. There is also an assertion that some people can recover from genuine alcoholism and then learn how to drink in balance, responsibly.</p>
    ),
  },
  {
    title: "The Republic",
    author: "Plato; trans. Jowett, Benjamin",
    date: "11/15/2016",
    content: (
      <p>The entirety of Western philosophy has been joked to be “footnotes to Plato.” More like, Plato helped build the foundation of the tradition still under construction. Plato paints a picture of the disorganized nature of statecraft that is more realistic than Thomas More’s Utopia and that causes a politically un-savvy person to shift back and forth until he finds balance amid both ambiguity and conflict. The reader also gains understanding and insight into the nature of power. With a firmly grounded political perspective, s/he can continue to effectively study political science without getting swept away by partisan currents. Props to the translator for preserving a very colloquial tone and pace.</p>
    ),
  },
]
